module.exports = "<div class=\"card tip\"> <img class=\"card-img-top\" src=\"assets/img/icon/ico-tip.png\" alt=\"Card image cap\">\n    <div class=\"card-body\"><span class=\"titleTip\">{{title}}</span>\n        <br> {{mesaje}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/card-tip/card-tip.component.html
// module id = ./src/app/components/shared/card-tip/card-tip.component.html
// module chunks = main